import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, AbstractControl } from "@angular/forms";
import { StorageService } from '../../services/storage.service';
import { AuthService } from '../../services/auth.service';
import swal from 'sweetalert2';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    host: { 'class': 'login-main' }
})
export class LoginComponent implements OnInit, OnDestroy {

    form: UntypedFormGroup;
    submitted: boolean = false;
    submitting: boolean = false;
    failedAttempts = 0;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private fb: UntypedFormBuilder,
        private authService: AuthService,
        private storageService: StorageService
    ) {
        /*
        this.storageService.clear();
        let email = this.route.snapshot.queryParams['email'];
        this.form = this.fb.group({
            'username': [email, Validators.compose([Validators.required, Validators.email])],
            'password': [null, Validators.required]
        });
        */
       window.location.assign("/identity/authorize");
    }

    ngOnInit() { }

    ngOnDestroy() { }

    /*
    submit(form: FormGroup) {
        this.submitted = true;
        if (form.invalid) return;
        this.submitting = true;
        form.disable();

        this.storageService.setItem('user', JSON.stringify({
            username: form.value.username
        }));

        this.authService.login(form.value.username, form.value.password).then(
            result => {
                this.router.navigate(['/portal']);
            },
            error => {
                this.submitting = false;
                form.enable();
                form.controls['password'].setErrors({ 'serverError': error.description });

                if (error.status != 400 && error.status != 401) {
                    swal(
                        'Login attempt failed',
                        error.description ? error.description : 'Please try again',
                        'error'
                    );
                }
            });
    }
            */

}
